module.exports = __webpack_public_path__ + "static/sesame-costco-10638d02cafe0925be25fed3d4997620.jpg";